<template>
  <div class="scrollbar-inner">
    <div class="card">
      <!-- Card header -->
      <div class="card-header">
        <!-- Title -->
        <h4 class="h3 mb-0">
          Multi User Picker
          <span
            data-toggle="tooltip"
            data-placement="bottom"
            title="Share this task with others using CCed just like email, but they are not responsible for the task. Search will search you entire network, but this list shows currently, then recently then project team members first."
          >
            <i class="far fa-question-circle"></i>
          </span>
        </h4>
      </div>
      <!-- Card search -->
      <div class="card-header py-0">
        <!-- Search form -->
        <form>
          <div class="form-group mb-0">
            <div class="input-group input-group-lg input-group-flush">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <span class="fas fa-search"></span>
                </div>
              </div>
              <input type="search" class="form-control" placeholder="Search" />
            </div>
          </div>
        </form>
      </div>
      <!-- Card body -->
      <div class="card-body px-2 py-3">
        <!-- List group -->
        <ul class="list-group list-group-flush list my--3">
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a href="#!" class="d-block">Rayan Thomson</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" checked />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-2.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Romina Hadid</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" checked />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-3.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Alexander Smith</a>
                </h5>
                <span class="text-danger">●</span>
                <small>Offline</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" checked />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Suman Khatiwada</a>
                </h5>
                <span class="text-danger">●</span>
                <small>Offline</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" checked />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
          <li class="list-group-item px-0">
            <div class="row align-items-center mx-1">
              <div class="col-auto px-1">
                <!-- Avatar -->
                <a href="#" class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="../../../assets/img/theme/team-1.jpg" />
                </a>
              </div>
              <div class="col ml-1 px-1">
                <h5 class="mb-0">
                  <a class="d-block" href="#!">Michael Simonetti</a>
                </h5>
                <span class="text-success">●</span>
                <small>Online</small>
              </div>
              <div class="col-auto px-1">
                <label class="custom-toggle">
                  <input type="checkbox" />
                  <span
                    class="custom-toggle-slider rounded-circle"
                    data-label-off="OFF"
                    data-label-on="ON"
                  ></span>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiUserPicker",
  data() {
    return {};
  }
};
</script>

<style lang="sass">

</style>